import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW0500Model } from './kymw0500.model';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { KYMW0500InputModel } from './vo/kymw0500-input.model';
import { GetRelatedDataModel } from './vo/get-related-data.model';
import { RelatedDataModel } from './vo/related-data.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { RegistRelatedDataModel } from './vo/regist-related-data.model';
import { GetGoodsDataModel } from './vo/get-goods-data.model';
import { GetRelatedDataService } from './api-services/get-related-data.service';
import { GetGoodsDataService } from './api-services/get-goods-data.service';
import { RegistRelatedDataService } from './api-services/regist-related-data.service';
import { PlanGoodsLockService } from '../../kymw00/api-services/plan-goods-lock.service';
// 項番2612 START
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
// 項番2612 END
const COOP_COUNT: number = <number>9;

/**
 * 紐付設定画面を管理するクラス
 *
 * @export KYMW0500Component
 * @class KYMW0500Component
 */
@Component({
  selector: 'app-kymw0500',
  templateUrl: 'kymw0500.component.html',
  styleUrls: ['kymw0500.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW0500Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw0500Model: KYMW0500Model = new KYMW0500Model();
  relatedDataVO: RelatedDataModel = new RelatedDataModel();
  setKYMW0500Parameter: Function;

  @ViewChild('btn_Return', { static: true }) btn_Return: ElementRef;
  @ViewChild('btn_Update', { static: true }) btn_Update: ElementRef;
  @ViewChild('btn_Close', { static: true }) btn_Close: ElementRef;
  @ViewChild('txti_pCode1', { static: true }) txti_pCode1: ElementRef;
  @ViewChild('txti_pCode2', { static: true }) txti_pCode2: ElementRef;
  @ViewChild('txti_pCode3', { static: true }) txti_pCode3: ElementRef;
  @ViewChild('txti_pCode4', { static: true }) txti_pCode4: ElementRef;
  @ViewChild('txti_pCode5', { static: true }) txti_pCode5: ElementRef;
  @ViewChild('txti_pCode6', { static: true }) txti_pCode6: ElementRef;
  @ViewChild('txti_pCode7', { static: true }) txti_pCode7: ElementRef;
  @ViewChild('txti_pCode8', { static: true }) txti_pCode8: ElementRef;
  @ViewChild('lbl_pCode0', { static: true }) lbl_pCode0: ElementRef;
  @ViewChild('chk_Ibaraki0', { static: true }) chk_Ibaraki0: ElementRef;
  @ViewChild('chk_Tochigi0', { static: true }) chk_Tochigi0: ElementRef;
  @ViewChild('chk_Gunma0', { static: true }) chk_Gunma0: ElementRef;
  @ViewChild('chk_Chiba0', { static: true }) chk_Chiba0: ElementRef;
  @ViewChild('chk_Saitama0', { static: true }) chk_Saitama0: ElementRef;
  @ViewChild('chk_Tokyo0', { static: true }) chk_Tokyo0: ElementRef;
  @ViewChild('chk_Nagano0', { static: true }) chk_Nagano0: ElementRef;
  @ViewChild('chk_Niigata0', { static: true }) chk_Niigata0: ElementRef;
  @ViewChild('chk_Kuruco0', { static: true }) chk_Kuruco0: ElementRef;

  @ViewChild('lbl_goodsName0', { static: true }) lbl_goodsName0: ElementRef;
  @ViewChild('lbl_goodsName1', { static: true }) lbl_goodsName1: ElementRef;
  @ViewChild('lbl_goodsName2', { static: true }) lbl_goodsName2: ElementRef;
  @ViewChild('lbl_goodsName3', { static: true }) lbl_goodsName3: ElementRef;
  @ViewChild('lbl_goodsName4', { static: true }) lbl_goodsName4: ElementRef;
  @ViewChild('lbl_goodsName5', { static: true }) lbl_goodsName5: ElementRef;
  @ViewChild('lbl_goodsName6', { static: true }) lbl_goodsName6: ElementRef;
  @ViewChild('lbl_goodsName7', { static: true }) lbl_goodsName7: ElementRef;
  @ViewChild('lbl_goodsName8', { static: true }) lbl_goodsName8: ElementRef;

  @ViewChild('lbl_standardName0', { static: true }) lbl_standardName0: ElementRef;
  @ViewChild('lbl_standardName1', { static: true }) lbl_standardName1: ElementRef;
  @ViewChild('lbl_standardName2', { static: true }) lbl_standardName2: ElementRef;
  @ViewChild('lbl_standardName3', { static: true }) lbl_standardName3: ElementRef;
  @ViewChild('lbl_standardName4', { static: true }) lbl_standardName4: ElementRef;
  @ViewChild('lbl_standardName5', { static: true }) lbl_standardName5: ElementRef;
  @ViewChild('lbl_standardName6', { static: true }) lbl_standardName6: ElementRef;
  @ViewChild('lbl_standardName7', { static: true }) lbl_standardName7: ElementRef;
  @ViewChild('lbl_standardName8', { static: true }) lbl_standardName8: ElementRef;

  @ViewChild('chk_Ibaraki1', { static: true }) chk_Ibaraki1: ElementRef;
  @ViewChild('chk_Ibaraki2', { static: true }) chk_Ibaraki2: ElementRef;
  @ViewChild('chk_Ibaraki3', { static: true }) chk_Ibaraki3: ElementRef;
  @ViewChild('chk_Ibaraki4', { static: true }) chk_Ibaraki4: ElementRef;
  @ViewChild('chk_Ibaraki5', { static: true }) chk_Ibaraki5: ElementRef;
  @ViewChild('chk_Ibaraki6', { static: true }) chk_Ibaraki6: ElementRef;
  @ViewChild('chk_Ibaraki7', { static: true }) chk_Ibaraki7: ElementRef;
  @ViewChild('chk_Ibaraki8', { static: true }) chk_Ibaraki8: ElementRef;

  @ViewChild('chk_Tochigi1', { static: true }) chk_Tochigi1: ElementRef;
  @ViewChild('chk_Tochigi2', { static: true }) chk_Tochigi2: ElementRef;
  @ViewChild('chk_Tochigi3', { static: true }) chk_Tochigi3: ElementRef;
  @ViewChild('chk_Tochigi4', { static: true }) chk_Tochigi4: ElementRef;
  @ViewChild('chk_Tochigi5', { static: true }) chk_Tochigi5: ElementRef;
  @ViewChild('chk_Tochigi6', { static: true }) chk_Tochigi6: ElementRef;
  @ViewChild('chk_Tochigi7', { static: true }) chk_Tochigi7: ElementRef;
  @ViewChild('chk_Tochigi8', { static: true }) chk_Tochigi8: ElementRef;

  @ViewChild('chk_Gunma1', { static: true }) chk_Gunma1: ElementRef;
  @ViewChild('chk_Gunma2', { static: true }) chk_Gunma2: ElementRef;
  @ViewChild('chk_Gunma3', { static: true }) chk_Gunma3: ElementRef;
  @ViewChild('chk_Gunma4', { static: true }) chk_Gunma4: ElementRef;
  @ViewChild('chk_Gunma5', { static: true }) chk_Gunma5: ElementRef;
  @ViewChild('chk_Gunma6', { static: true }) chk_Gunma6: ElementRef;
  @ViewChild('chk_Gunma7', { static: true }) chk_Gunma7: ElementRef;
  @ViewChild('chk_Gunma8', { static: true }) chk_Gunma8: ElementRef;

  @ViewChild('chk_Chiba1', { static: true }) chk_Chiba1: ElementRef;
  @ViewChild('chk_Chiba2', { static: true }) chk_Chiba2: ElementRef;
  @ViewChild('chk_Chiba3', { static: true }) chk_Chiba3: ElementRef;
  @ViewChild('chk_Chiba4', { static: true }) chk_Chiba4: ElementRef;
  @ViewChild('chk_Chiba5', { static: true }) chk_Chiba5: ElementRef;
  @ViewChild('chk_Chiba6', { static: true }) chk_Chiba6: ElementRef;
  @ViewChild('chk_Chiba7', { static: true }) chk_Chiba7: ElementRef;
  @ViewChild('chk_Chiba8', { static: true }) chk_Chiba8: ElementRef;

  @ViewChild('chk_Saitama1', { static: true }) chk_Saitama1: ElementRef;
  @ViewChild('chk_Saitama2', { static: true }) chk_Saitama2: ElementRef;
  @ViewChild('chk_Saitama3', { static: true }) chk_Saitama3: ElementRef;
  @ViewChild('chk_Saitama4', { static: true }) chk_Saitama4: ElementRef;
  @ViewChild('chk_Saitama5', { static: true }) chk_Saitama5: ElementRef;
  @ViewChild('chk_Saitama6', { static: true }) chk_Saitama6: ElementRef;
  @ViewChild('chk_Saitama7', { static: true }) chk_Saitama7: ElementRef;
  @ViewChild('chk_Saitama8', { static: true }) chk_Saitama8: ElementRef;

  @ViewChild('chk_Tokyo1', { static: true }) chk_Tokyo1: ElementRef;
  @ViewChild('chk_Tokyo2', { static: true }) chk_Tokyo2: ElementRef;
  @ViewChild('chk_Tokyo3', { static: true }) chk_Tokyo3: ElementRef;
  @ViewChild('chk_Tokyo4', { static: true }) chk_Tokyo4: ElementRef;
  @ViewChild('chk_Tokyo5', { static: true }) chk_Tokyo5: ElementRef;
  @ViewChild('chk_Tokyo6', { static: true }) chk_Tokyo6: ElementRef;
  @ViewChild('chk_Tokyo7', { static: true }) chk_Tokyo7: ElementRef;
  @ViewChild('chk_Tokyo8', { static: true }) chk_Tokyo8: ElementRef;

  @ViewChild('chk_Nagano1', { static: true }) chk_Nagano1: ElementRef;
  @ViewChild('chk_Nagano2', { static: true }) chk_Nagano2: ElementRef;
  @ViewChild('chk_Nagano3', { static: true }) chk_Nagano3: ElementRef;
  @ViewChild('chk_Nagano4', { static: true }) chk_Nagano4: ElementRef;
  @ViewChild('chk_Nagano5', { static: true }) chk_Nagano5: ElementRef;
  @ViewChild('chk_Nagano6', { static: true }) chk_Nagano6: ElementRef;
  @ViewChild('chk_Nagano7', { static: true }) chk_Nagano7: ElementRef;
  @ViewChild('chk_Nagano8', { static: true }) chk_Nagano8: ElementRef;

  @ViewChild('chk_Niigata1', { static: true }) chk_Niigata1: ElementRef;
  @ViewChild('chk_Niigata2', { static: true }) chk_Niigata2: ElementRef;
  @ViewChild('chk_Niigata3', { static: true }) chk_Niigata3: ElementRef;
  @ViewChild('chk_Niigata4', { static: true }) chk_Niigata4: ElementRef;
  @ViewChild('chk_Niigata5', { static: true }) chk_Niigata5: ElementRef;
  @ViewChild('chk_Niigata6', { static: true }) chk_Niigata6: ElementRef;
  @ViewChild('chk_Niigata7', { static: true }) chk_Niigata7: ElementRef;
  @ViewChild('chk_Niigata8', { static: true }) chk_Niigata8: ElementRef;

  @ViewChild('chk_Kuruco1', { static: true }) chk_Kuruco1: ElementRef;
  @ViewChild('chk_Kuruco2', { static: true }) chk_Kuruco2: ElementRef;
  @ViewChild('chk_Kuruco3', { static: true }) chk_Kuruco3: ElementRef;
  @ViewChild('chk_Kuruco4', { static: true }) chk_Kuruco4: ElementRef;
  @ViewChild('chk_Kuruco5', { static: true }) chk_Kuruco5: ElementRef;
  @ViewChild('chk_Kuruco6', { static: true }) chk_Kuruco6: ElementRef;
  @ViewChild('chk_Kuruco7', { static: true }) chk_Kuruco7: ElementRef;
  @ViewChild('chk_Kuruco8', { static: true }) chk_Kuruco8: ElementRef;

  // 受渡情報
  public inputVo: KYMW0500InputModel = null;

  // フォーカス行
  public focusedRow: number = <number>-1;

  // コントロールグループ
  public grpPCode: Array<any> = new Array<any>();
  public grpGoodsName: Array<any> = new Array<any>();
  public grpStandardName: Array<any> = new Array<any>();
  public grpCbIB: Array<any> = new Array<any>();
  public grpCbTO: Array<any> = new Array<any>();
  public grpCbGU: Array<any> = new Array<any>();
  public grpCbTI: Array<any> = new Array<any>();
  public grpCbSA: Array<any> = new Array<any>();
  public grpCbTK: Array<any> = new Array<any>();
  public grpCbNA: Array<any> = new Array<any>();
  public grpCbNI: Array<any> = new Array<any>();

  public grpCbKU: Array<any> = new Array<any>();

  /**
   *Creates an instance of KYMW0500Component.
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0500Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getRelatedDataService: GetRelatedDataService,
    private getGoodsDataService: GetGoodsDataService,
    private registRelatedDataService: RegistRelatedDataService,
    private planGoodsLockServiceSub: PlanGoodsLockService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW0500Component
   */
  public ngOnInit() {
    this.kymw0500Model.kymw0500Component = this;
    this.componentName = 'KYMW0500';
    this.planGoodsLockService = this.planGoodsLockServiceSub;
    this.bindPropertySetting();

    // 紐付設定画面データ取得要求をサーバに送信する
    const vo = new GetRelatedDataModel;
    vo.processDiv = this.kymw0500Model.processDiv;
    vo.orderCode = this.kymw0500Model.orderCode;
    vo.mainPCode = this.kymw0500Model.mainPCode;

    this.getRelatedDataService.execute(this.kymw0500Model, vo);

    // 活性制御
    setTimeout(() => {
      // 活性・非活性制御処理
      this.plessEnabledSetting();
    });
  }

  /**
   * 活性・非活性制御処理
   *
   * @memberof KYMW0500Component
   */
  public plessEnabledSetting(): void {
    // 【初期状態】【設定】ボタンの活性制御を行う
    this.plessEnabled(this.btn_Return, this.kymw0500Model.editMode);
    this.plessEnabled(this.btn_Update, this.kymw0500Model.editMode);
  }

  public bindPropertySetting(): void {
    // 紐付設定画面データリストの初期化
    for (let i = Number(0); i < COOP_COUNT; i++) {
      this.kymw0500Model.relatedDataList.push(new RelatedDataModel());
    }

    this.grpPCode.push(this.lbl_pCode0);
    this.grpPCode.push(this.txti_pCode1);
    this.grpPCode.push(this.txti_pCode2);
    this.grpPCode.push(this.txti_pCode3);
    this.grpPCode.push(this.txti_pCode4);
    this.grpPCode.push(this.txti_pCode5);
    this.grpPCode.push(this.txti_pCode6);
    this.grpPCode.push(this.txti_pCode7);
    this.grpPCode.push(this.txti_pCode8);

    this.grpGoodsName.push(this.lbl_goodsName0);
    this.grpGoodsName.push(this.lbl_goodsName1);
    this.grpGoodsName.push(this.lbl_goodsName2);
    this.grpGoodsName.push(this.lbl_goodsName3);
    this.grpGoodsName.push(this.lbl_goodsName4);
    this.grpGoodsName.push(this.lbl_goodsName5);
    this.grpGoodsName.push(this.lbl_goodsName6);
    this.grpGoodsName.push(this.lbl_goodsName7);
    this.grpGoodsName.push(this.lbl_goodsName8);

    this.grpStandardName.push(this.lbl_standardName0);
    this.grpStandardName.push(this.lbl_standardName1);
    this.grpStandardName.push(this.lbl_standardName2);
    this.grpStandardName.push(this.lbl_standardName3);
    this.grpStandardName.push(this.lbl_standardName4);
    this.grpStandardName.push(this.lbl_standardName5);
    this.grpStandardName.push(this.lbl_standardName6);
    this.grpStandardName.push(this.lbl_standardName7);
    this.grpStandardName.push(this.lbl_standardName8);

    this.grpCbIB.push(this.chk_Ibaraki0);
    this.grpCbIB.push(this.chk_Ibaraki1);
    this.grpCbIB.push(this.chk_Ibaraki2);
    this.grpCbIB.push(this.chk_Ibaraki3);
    this.grpCbIB.push(this.chk_Ibaraki4);
    this.grpCbIB.push(this.chk_Ibaraki5);
    this.grpCbIB.push(this.chk_Ibaraki6);
    this.grpCbIB.push(this.chk_Ibaraki7);
    this.grpCbIB.push(this.chk_Ibaraki8);

    this.grpCbTO.push(this.chk_Tochigi0);
    this.grpCbTO.push(this.chk_Tochigi1);
    this.grpCbTO.push(this.chk_Tochigi2);
    this.grpCbTO.push(this.chk_Tochigi3);
    this.grpCbTO.push(this.chk_Tochigi4);
    this.grpCbTO.push(this.chk_Tochigi5);
    this.grpCbTO.push(this.chk_Tochigi6);
    this.grpCbTO.push(this.chk_Tochigi7);
    this.grpCbTO.push(this.chk_Tochigi8);

    this.grpCbGU.push(this.chk_Gunma0);
    this.grpCbGU.push(this.chk_Gunma1);
    this.grpCbGU.push(this.chk_Gunma2);
    this.grpCbGU.push(this.chk_Gunma3);
    this.grpCbGU.push(this.chk_Gunma4);
    this.grpCbGU.push(this.chk_Gunma5);
    this.grpCbGU.push(this.chk_Gunma6);
    this.grpCbGU.push(this.chk_Gunma7);
    this.grpCbGU.push(this.chk_Gunma8);

    this.grpCbTI.push(this.chk_Chiba0);
    this.grpCbTI.push(this.chk_Chiba1);
    this.grpCbTI.push(this.chk_Chiba2);
    this.grpCbTI.push(this.chk_Chiba3);
    this.grpCbTI.push(this.chk_Chiba4);
    this.grpCbTI.push(this.chk_Chiba5);
    this.grpCbTI.push(this.chk_Chiba6);
    this.grpCbTI.push(this.chk_Chiba7);
    this.grpCbTI.push(this.chk_Chiba8);

    this.grpCbSA.push(this.chk_Saitama0);
    this.grpCbSA.push(this.chk_Saitama1);
    this.grpCbSA.push(this.chk_Saitama2);
    this.grpCbSA.push(this.chk_Saitama3);
    this.grpCbSA.push(this.chk_Saitama4);
    this.grpCbSA.push(this.chk_Saitama5);
    this.grpCbSA.push(this.chk_Saitama6);
    this.grpCbSA.push(this.chk_Saitama7);
    this.grpCbSA.push(this.chk_Saitama8);

    this.grpCbTK.push(this.chk_Tokyo0);
    this.grpCbTK.push(this.chk_Tokyo1);
    this.grpCbTK.push(this.chk_Tokyo2);
    this.grpCbTK.push(this.chk_Tokyo3);
    this.grpCbTK.push(this.chk_Tokyo4);
    this.grpCbTK.push(this.chk_Tokyo5);
    this.grpCbTK.push(this.chk_Tokyo6);
    this.grpCbTK.push(this.chk_Tokyo7);
    this.grpCbTK.push(this.chk_Tokyo8);

    this.grpCbNA.push(this.chk_Nagano0);
    this.grpCbNA.push(this.chk_Nagano1);
    this.grpCbNA.push(this.chk_Nagano2);
    this.grpCbNA.push(this.chk_Nagano3);
    this.grpCbNA.push(this.chk_Nagano4);
    this.grpCbNA.push(this.chk_Nagano5);
    this.grpCbNA.push(this.chk_Nagano6);
    this.grpCbNA.push(this.chk_Nagano7);
    this.grpCbNA.push(this.chk_Nagano8);

    this.grpCbNI.push(this.chk_Niigata0);
    this.grpCbNI.push(this.chk_Niigata1);
    this.grpCbNI.push(this.chk_Niigata2);
    this.grpCbNI.push(this.chk_Niigata3);
    this.grpCbNI.push(this.chk_Niigata4);
    this.grpCbNI.push(this.chk_Niigata5);
    this.grpCbNI.push(this.chk_Niigata6);
    this.grpCbNI.push(this.chk_Niigata7);
    this.grpCbNI.push(this.chk_Niigata8);

    // クルコ
    this.grpCbKU.push(this.chk_Kuruco0);
    this.grpCbKU.push(this.chk_Kuruco1);
    this.grpCbKU.push(this.chk_Kuruco2);
    this.grpCbKU.push(this.chk_Kuruco3);
    this.grpCbKU.push(this.chk_Kuruco4);
    this.grpCbKU.push(this.chk_Kuruco5);
    this.grpCbKU.push(this.chk_Kuruco6);
    this.grpCbKU.push(this.chk_Kuruco7);
    this.grpCbKU.push(this.chk_Kuruco8);
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW0500Component
   */
  public setInterfaceParam(param: any): void {
    this.inputVo = <KYMW0500InputModel>param;
    // 受渡情報をmanageに格納
    this.kymw0500Model.editMode = this.inputVo.editMode;
    this.kymw0500Model.processDiv = this.inputVo.processDiv;
    this.kymw0500Model.orderCode = this.inputVo.orderCode;
    this.kymw0500Model.mediumType = this.inputVo.mediumType;
    this.kymw0500Model.mainPCode = this.inputVo.mainPCode;
  }

  /**
     * 【閉じる】ボタン クリック時の処理
     *
     * @param event : MouseEvent
     */
  public eventBtnClose_CLICKHandler(event: MouseEvent = null): void {

    if (event === null &&
      this.kymw0500Model.processDiv === '2') {

      // 呼出元画面に検索条件,選択行を返却する
      this.setKYMW0500Parameter(null);
    }

    // 排他情報の解放
    this.releaseLock();
    this.closeFunction();
  }

  /**
   * 【初期状態】ボタン クリック時の処理
   *
   * @param event : MouseEvent
   */
  public eventBtnReturn_CLICKHandler(evnet: MouseEvent): void {

    // 排他情報の開放
    this.releaseLock(() => {
      // 紐付設定画面データ取得要求をサーバに送信する
      const vo = new GetRelatedDataModel;
      vo.processDiv = this.kymw0500Model.processDiv;
      vo.orderCode = this.kymw0500Model.orderCode;
      vo.mainPCode = this.kymw0500Model.mainPCode;

      this.getRelatedDataService.execute(this.kymw0500Model, vo);
    });
  }

  /**
   * 【取扱生協】チェックボックス チェンジ時の処理
   *
   * @param event : Event
   */
  public eventChkIbaraki_CHANGEHandler(event: any): void {
    this.eventChkBox_CHANGEHandler(event, this.grpCbIB);
  }
  public eventChkTochigi_CHANGEHandler(event: any): void {
    this.eventChkBox_CHANGEHandler(event, this.grpCbTO);
  }
  public eventChkGunma_CHANGEHandler(event: any): void {
    this.eventChkBox_CHANGEHandler(event, this.grpCbGU);
  }
  public eventChkChiba_CHANGEHandler(event: any): void {
    this.eventChkBox_CHANGEHandler(event, this.grpCbTI);
  }
  public eventChkSaitama_CHANGEHandler(event: any): void {
    this.eventChkBox_CHANGEHandler(event, this.grpCbSA);
  }
  public eventChkTokyo_CHANGEHandler(event: any): void {
    this.eventChkBox_CHANGEHandler(event, this.grpCbTK);
  }
  public eventChkNagano_CHANGEHandler(event: any): void {
    this.eventChkBox_CHANGEHandler(event, this.grpCbNA);
  }
  public eventChkNiigata_CHANGEHandler(event: any): void {
    this.eventChkBox_CHANGEHandler(event, this.grpCbNI);
  }

  public eventChkKuruco_CHANGEHandler(event: any): void {
    this.eventChkBox_CHANGEHandler(event, this.grpCbKU);
  }

  public eventChkBox_CHANGEHandler(event: any, grpChkBox: Array<any>): void {
    let tempData: RelatedDataModel;
    for (let i = Number(0); i < this.kymw0500Model.relatedDataList.length; i++) {
      tempData = this.kymw0500Model.relatedDataList[i];
      if (event.currentTarget.id !== grpChkBox[i].nativeElement.id) {

        if (grpChkBox === this.grpCbIB) {
          tempData.selectedIB = false;
        } else if (grpChkBox === this.grpCbTO) {
          tempData.selectedTO = false;
        } else if (grpChkBox === this.grpCbGU) {
          tempData.selectedGU = false;
        } else if (grpChkBox === this.grpCbTI) {
          tempData.selectedTI = false;
        } else if (grpChkBox === this.grpCbSA) {
          tempData.selectedSA = false;
        } else if (grpChkBox === this.grpCbTK) {
          tempData.selectedTK = false;
        } else if (grpChkBox === this.grpCbNA) {
          tempData.selectedNA = false;
        } else if (grpChkBox === this.grpCbNI) {
          tempData.selectedNI = false;
        } else if (grpChkBox === this.grpCbKU) {
          tempData.selectedKU = false;
        }
      }
      this.kymw0500Model.relatedDataList[i] = tempData;
    }
    this.setEnabledBtnUpdate();
  }

  /**
   * 【Ｐコード】テキスト チェンジ時の処理
   *
   * @param event : Event
   */
  public eventTxtPCode_CHANGEHandler(event: any): void {

    let index: number = <number>1;
    const targetPCode: HTMLInputElement = event.currentTarget;

    for (index; index < this.kymw0500Model.relatedDataList.length; index++) {
      if (event.currentTarget.id === this.grpPCode[index].nativeElement.id) {
        break;
      }
    }

    if (targetPCode.value.length === targetPCode.maxLength) {

      // 全桁入力時

      // Ｐコード重複チェック
      if (!this.isOnlyPCode(targetPCode, index)) {
        this.dialogService.openAlertGetMessage('E0115', ['Ｐコード']);
        return;
      }

      // 商品情報取得要求をサーバに送信する
      const vo = new GetGoodsDataModel();
      vo.processDiv = this.kymw0500Model.processDiv;
      vo.orderCode = this.kymw0500Model.orderCode;
      vo.mediumType = this.kymw0500Model.mediumType;
      vo.mainPCode = this.kymw0500Model.mainPCode;
      vo.pCode = targetPCode.value;
      vo.index = index;
      this.getGoodsDataService.execute(this.kymw0500Model, vo);
    } else {
      if (this.kymw0500Model.relatedDataList[index].originPCode.length === targetPCode.maxLength) {
        // 排他情報の開放
        this.LockUtilForPlanGoods('RELEASE',
          this.kymw0500Model.orderCode,
          this.kymw0500Model.mediumType,
          this.kymw0500Model.relatedDataList[index].originPCode,
          null, null, null, null, false);
      }
      // 行データの初期化
      this.kymw0500Model.clearRowData(index, targetPCode.value);
    }
  }

  /**
   * 「設定」ボタン押下時の処理
   * @param event コールバック・イベントへの参照
   */
  public eventBtnUpdate_CLICKHandler(): void {

    // 登録確認メッセージを表示する
    if (this.isCheckChild()) {
      // 子商品が選択されている場合

      if (this.kymw0500Model.processDiv === '1') {
        // 『商品登録』画面から呼出時
        this.dialogService.openAlertGetMessage('Q0100', null, (closeDetail: number) => {
          this.eventAlert1_CLICKHandler(closeDetail);
        });		// 「紐付設定を本当に変更しますか？」
      } else {
        // 『商品企画マスタ』画面から呼出時
        this.dialogService.openAlertGetMessage('Q0102', null, (closeDetail: number) => {
          this.eventAlert1_CLICKHandler(closeDetail);
        });		// 「紐付を本当に変更しますか？変更後、元に戻すことはできません」
      }
    } else {
      // 子商品が選択されていない場合

      if (this.kymw0500Model.processMode === '1') {
        // 新規登録時
        this.dialogService.openAlertGetMessage('E0103', ['紐付商品']);			// 「紐付商品が選択されていません」
      } else {
        // 変更時
        this.dialogService.openAlertGetMessage('Q0101', null, (closeDetail: number) => {
          this.eventAlert1_CLICKHandler(closeDetail);
        });		// 「紐付設定を解除しますか？」
      }
    }
  }

  /**
   * 登録確認メッセージ 確認時の処理
   *
   * @param closeEvent コールバック・イベントへの参照
   */
  public eventAlert1_CLICKHandler(closedetail: number): void {

    if (closedetail === PlessAlert.Yes) {

      // 紐付情報設定要求をサーバに送信する

      const vo = new RegistRelatedDataModel();
      vo.processDiv = this.kymw0500Model.processDiv;
      vo.orderCode = this.kymw0500Model.orderCode;
      vo.mainPCode = this.kymw0500Model.mainPCode;

      let cnt = 0;

      for (const tempData of this.kymw0500Model.relatedDataList) {

        if (tempData.selectedIB || tempData.selectedTO || tempData.selectedGU || tempData.selectedTI ||
          tempData.selectedSA || tempData.selectedTK || tempData.selectedNA || tempData.selectedNI ||
          tempData.selectedKU) {
          vo.relatedDataList.push(tempData);
          cnt += 1;
        } else if (!tempData.enabledPCode) {
          vo.relatedDataList.push(tempData);
        }
      }

      if (cnt > 1) {
        vo.processMode = this.kymw0500Model.processMode;
      } else {
        vo.processMode = '3';
      }

      this.registRelatedDataService.execute(this.kymw0500Model, vo);
    }
  }
  /**
   * 指定行にフォーカスをセットする
   */
  public setFocusRow(): void {

    if (this.focusedRow === -1) {

      if (this.kymw0500Model.relatedDataList[1].enabledPCode) {
        this.focusedRow = 1;
      } else if (this.kymw0500Model.relatedDataList[2].enabledPCode) {
        this.focusedRow = 2;
      } else if (this.kymw0500Model.relatedDataList[3].enabledPCode) {
        this.focusedRow = 3;
      } else if (this.kymw0500Model.relatedDataList[4].enabledPCode) {
        this.focusedRow = 4;
      } else if (this.kymw0500Model.relatedDataList[5].enabledPCode) {
        this.focusedRow = 5;
      } else if (this.kymw0500Model.relatedDataList[6].enabledPCode) {
        this.focusedRow = 6;
      } else if (this.kymw0500Model.relatedDataList[7].enabledPCode) {
        this.focusedRow = 7;
      } else if (this.kymw0500Model.relatedDataList[8].enabledPCode) {
        this.focusedRow = 8;
      }
    }

    // 画面描画のタイミングでdisabledが解除されていないとfocusが当たらないので1秒待つ
    setTimeout(
      () => {
        if (this.getFuncPermission('KYMW1100') !== this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {  // 「2：フルコントロール可能」以外の場合
          this.btn_Close.nativeElement.focus();
          return;
        }

        switch (this.focusedRow) {
          case 1:
            this.txti_pCode1.nativeElement.focus();
            break;
          case 2:
            this.txti_pCode2.nativeElement.focus();
            break;
          case 3:
            this.txti_pCode3.nativeElement.focus();
            break;
          case 4:
            this.txti_pCode4.nativeElement.focus();
            break;
          case 5:
            this.txti_pCode5.nativeElement.focus();
            break;
          case 6:
            this.txti_pCode6.nativeElement.focus();
            break;
          case 7:
            this.txti_pCode7.nativeElement.focus();
            break;
          case 8:
            this.txti_pCode8.nativeElement.focus();
            break;
          default:
            this.btn_Close.nativeElement.focus();
        }
        this.focusedRow = -1;
      });
  }

  /**
   * 【設定】ボタン活性制御
   */
  public setEnabledBtnUpdate(): void {
    // 編集モードの場合、制御を行わない
    if (!this.kymw0500Model.editMode) {
      return;
    }
    const tempData: RelatedDataModel = this.kymw0500Model.relatedDataList[0];
    if (tempData.selectedIB || tempData.selectedTO ||
      tempData.selectedGU || tempData.selectedTI ||
      tempData.selectedSA || tempData.selectedTK ||
      tempData.selectedNA || tempData.selectedNI ||
      tempData.selectedKU) {
      this.plessEnabled(this.btn_Update, true);
    } else {
      this.plessEnabled(this.btn_Update, false);
    }
  }

  /**
   * 子商品選択有無チェック
   *
   * @return Boolean
   */
  public isCheckChild(): boolean {
    for (let i = 1; i < this.kymw0500Model.relatedDataList.length; i++) {
      if (this.kymw0500Model.relatedDataList[i].selectedIB ||
        this.kymw0500Model.relatedDataList[i].selectedTO ||
        this.kymw0500Model.relatedDataList[i].selectedGU ||
        this.kymw0500Model.relatedDataList[i].selectedTI ||
        this.kymw0500Model.relatedDataList[i].selectedSA ||
        this.kymw0500Model.relatedDataList[i].selectedTK ||
        this.kymw0500Model.relatedDataList[i].selectedNA ||
        this.kymw0500Model.relatedDataList[i].selectedNI ||
        this.kymw0500Model.relatedDataList[i].selectedKU) {
        return true;
      }
    }
    return false;
  }

  /**
   * Ｐコード重複チェック
   *
   * @param 	targetPCode : TextInput
   * @return	Boolean
   */
  public isOnlyPCode(targetPCode: HTMLInputElement, index: number): boolean {
    if (targetPCode.value === this.kymw0500Model.relatedDataList[0].pCode) {
      return false;
    }

    for (let i = 1; i < this.kymw0500Model.relatedDataList.length; i++) {
      // 自身との比較はスキップする
      if (i === index) {
        continue;
      }
      const tempPCode = this.kymw0500Model.relatedDataList[i].pCode;

      if (targetPCode.value === tempPCode) {
        return false;
      }
    }

    return true;
  }

  /**
   * 排他ロック成功時
   */
  public lockOK_Init(): void {

    // 【設定】ボタン活性制御
    this.setEnabledBtnUpdate();

    this.setFocusRow();
  }

  public lockOK_Row(event: any = null): void {

    if (event !== null) {

      // ロック対象Ｐコードを退避
      if (event.funcParam instanceof Array) {
        this.kymw0500Model.lockPCodeList = event;
      } else {
        this.kymw0500Model.lockPCodeList.push(event);
      }
    }

    this.setFocusRow();
  }

  /**
   * 排他ロック失敗時
   */
  // 項番2612 START
  //  public lockErr_Init(event: any): void {
  public lockErr_Init({ event, result }: { event: any; result: any; }): void {
    // 項番2612 END

    this.releaseLock();

    this.plessEnabled(this.btn_Update, false);

    for (let i = 0; i < this.kymw0500Model.relatedDataList.length; i++) {

      this.plessEnabled(this.grpPCode[i], false);
      this.plessEnabled(this.grpCbIB[i], false);
      this.plessEnabled(this.grpCbTO[i], false);
      this.plessEnabled(this.grpCbGU[i], false);
      this.plessEnabled(this.grpCbTI[i], false);
      this.plessEnabled(this.grpCbSA[i], false);
      this.plessEnabled(this.grpCbTK[i], false);
      this.plessEnabled(this.grpCbNA[i], false);
      this.plessEnabled(this.grpCbNI[i], false);
      this.plessEnabled(this.grpCbKU[i], false);

      this.kymw0500Model.relatedDataList[i].enabledPCode = false;
      this.kymw0500Model.relatedDataList[i].enabledIB = false;
      this.kymw0500Model.relatedDataList[i].enabledTO = false;
      this.kymw0500Model.relatedDataList[i].enabledGU = false;
      this.kymw0500Model.relatedDataList[i].enabledTI = false;
      this.kymw0500Model.relatedDataList[i].enabledSA = false;
      this.kymw0500Model.relatedDataList[i].enabledTK = false;
      this.kymw0500Model.relatedDataList[i].enabledNA = false;
      this.kymw0500Model.relatedDataList[i].enabledNI = false;
      this.kymw0500Model.relatedDataList[i].enabledKU = false;
    }

    this.setFocusRow();

    let UserName = '';
    if (result.result.obj.UnlockedInfo.Catalog[0] != null) {
      UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Catalog[0].UserName) + ']';
    } else if (result.result.obj.UnlockedInfo.Page[0] != null) {
      UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Page[0].UserName) + ']';
    } else {
      UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.PlanGoods[0].UserName) + ']';
    }
    this.dialogService.openAlertGetMessage('E0141', [UserName]);
  }

  public lockErr_Row({ result }: { result: any; }): void {

    const vo: RelatedDataModel = this.kymw0500Model.relatedDataList[this.focusedRow];

    this.kymw0500Model.clearRowData(this.focusedRow, vo.pCode);

    this.setFocusRow();

    let UserName = '';
    if (result.result.obj.UnlockedInfo.Catalog[0] != null) {
      UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Catalog[0].UserName) + ']';
    } else if (result.result.obj.UnlockedInfo.Page[0] != null) {
      UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Page[0].UserName) + ']';
    } else {
      UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.PlanGoods[0].UserName) + ']';
    }
    this.dialogService.openAlertGetMessage('E0141', [UserName]);
  }


  /**
   * 排他情報の開放
   */
  public releaseLock(afterFunc: Function = null): void {

    if (this.kymw0500Model.processDiv !== '1') {

      this.LockUtilForPlanGoods('RELEASE',
        this.kymw0500Model.orderCode,
        this.kymw0500Model.mediumType,
        this.kymw0500Model.lockPCodeList,
        afterFunc == null ? null : () => afterFunc(),
        afterFunc == null ? null : () => afterFunc(),
        null, null, false);
    }

    this.kymw0500Model.lockPCodeList = new Array<any>();
  }
}
